import type { SVGAttributes } from "react";

export default function ProfileIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5708 15.9142C16.3783 15.1554 17.0216 14.2391 17.461 13.2218C17.9003 12.2046 18.1263 11.1081 18.125 10C18.125 5.5125 14.4875 1.875 10 1.875C5.51251 1.875 1.87501 5.5125 1.87501 10C1.87372 11.1081 2.09973 12.2046 2.53905 13.2218C2.97837 14.2391 3.62166 15.1554 4.42917 15.9142C5.93495 17.3366 7.92863 18.1278 10 18.125C12.0714 18.1278 14.0651 17.3366 15.5708 15.9142ZM5.12084 14.8433C5.7059 14.1114 6.44835 13.5206 7.29304 13.1149C8.13772 12.7092 9.06295 12.4991 10 12.5C10.9371 12.4991 11.8623 12.7092 12.707 13.1149C13.5517 13.5206 14.2941 14.1114 14.8792 14.8433C14.2409 15.4881 13.4809 15.9997 12.6433 16.3484C11.8058 16.6972 10.9073 16.8762 10 16.875C9.09273 16.8762 8.19426 16.6972 7.35669 16.3484C6.51913 15.9997 5.75915 15.4881 5.12084 14.8433ZM13.125 7.5C13.125 8.3288 12.7958 9.12366 12.2097 9.70971C11.6237 10.2958 10.8288 10.625 10 10.625C9.1712 10.625 8.37635 10.2958 7.7903 9.70971C7.20425 9.12366 6.87501 8.3288 6.87501 7.5C6.87501 6.6712 7.20425 5.87634 7.7903 5.29029C8.37635 4.70424 9.1712 4.375 10 4.375C10.8288 4.375 11.6237 4.70424 12.2097 5.29029C12.7958 5.87634 13.125 6.6712 13.125 7.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
